import React, { createContext, useContext, useState } from 'react';

import CategoryHeader from '@/components/header/CategoryHeader';
import ContentHeader from '../header/ContentHeader';
import PageSectionHeader from '../header/UserManagement';

type HeaderType =
  | {
      type: 'content';
      props: React.ComponentProps<typeof ContentHeader>;
    }
  | {
      type: 'category';
      props: React.ComponentProps<typeof CategoryHeader>;
    }
  | {
      type: 'user';
      props: React.ComponentProps<typeof PageSectionHeader>;
    }
  | null;

interface HeaderContextType {
  header: HeaderType;
  setHeader: React.Dispatch<React.SetStateAction<HeaderType>>;
}

const HeaderContext = createContext<HeaderContextType | undefined>(undefined);

export const useHeader = () => {
  const context = useContext(HeaderContext);
  if (!context) throw new Error('useHeader must be used within HeaderProvider');
  return context;
};

export const HeaderProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [header, setHeader] = useState<HeaderType>(null);

  return <HeaderContext.Provider value={{ header, setHeader }}>{children}</HeaderContext.Provider>;
};
